module.exports = __webpack_public_path__ + "img/oufu_63_5x79_6x8.prt.ebc32eaf.jpg";